import React from 'react';

import { MuiThemeProvider } from '@material-ui/core/styles';
import { createBrowserHistory } from 'history';
import { Switch, Redirect, BrowserRouter } from 'react-router-dom';
import CssBaseline from '@material-ui/core/CssBaseline';
import RouterWrapper from './routerWrapper';
import SignIn from './pages/SignIn';
import Grupos from './pages/Grupos';
import AdicionarMembro from './pages/AdicionarMembro';
import CadastrarMembro from './pages/CadastrarMembro';
import theme from './styles';
import ControlePalavraFest from './pages/ControlePalavraFest';
import Main from './pages/_layouts/Main';

import BibliaOn from './pages/BibliaOn';
import Evento from './pages/Evento';
import Desafio from './pages/Desafio';
import CadastrarCrianca from './pages/CadastrarCrianca';
import AtualizarGrupo from './pages/AtualizarGrupo';
import Frequencia from './pages/Frequencia';
import FaltasJ1 from './pages/FaltasJ1';

const browserHistory = createBrowserHistory();

function App() {
    return (
        <MuiThemeProvider theme={theme}>
            <BrowserRouter history={browserHistory}>
                <CssBaseline />
                <Switch>
                    <RouterWrapper path={['/login']} component={SignIn} />
                    <RouterWrapper
                        path={[
                            '/grupos',
                            '/faltas_j1',
                            //'/frequencia',
                            //'/controle_palavra_fest',
                            //'/biblia_on',
                            //'/desafio',
                            '/adicionar_membro/:idGrupoPequeno/:idIgreja',
                            //'/cadastrar_crianca/:idMembro',
                            //'/cadastrar_novo_membro/:idGrupoPequeno/:idIgreja',
                            '/membro/:idIgreja/:idMembro',
                            //'/evento',
                            //'/crianca/:idMembro/:idCrianca',
                            '/atualizar_grupo/:idGrupoPequeno',
                        ]}
                        isPrivate
                    >
                        <Main>
                            <RouterWrapper
                                exact
                                path="/grupos/:indexGrupo?"
                                component={Grupos}
                                isPrivate
                            />
                            <RouterWrapper
                                exact
                                path="/faltas_j1"
                                component={FaltasJ1}
                                isPrivate
                            />
                            {/* <RouterWrapper
                                exact
                                path="/frequencia"
                                component={Frequencia}
                                isPrivate
                            /> */}
                            {/* <RouterWrapper
                                exact
                                path="/controle_palavra_fest/:indexGrupo?"
                                component={ControlePalavraFest}
                                isPrivate
                            /> */}
                            {/* <RouterWrapper
                                exact
                                path="/biblia_on/:indexGrupo?"
                                component={BibliaOn}
                                isPrivate
                            />
                            <RouterWrapper
                                exact
                                path="/desafio/:indexGrupo?"
                                component={Desafio}
                                isPrivate
                            />
                            <RouterWrapper
                                exact
                                path="/evento/:indexGrupo?"
                                component={Evento}
                                isPrivate
                            /> */}
                            <RouterWrapper
                                exact
                                path="/adicionar_membro/:idGrupoPequeno/:idIgreja"
                                component={AdicionarMembro}
                                isPrivate
                            />
                            {/* <RouterWrapper
                                exact
                                path="/cadastrar_novo_membro/:idGrupoPequeno/:idIgreja"
                                component={CadastrarMembro}
                                isPrivate
                            />
                            <RouterWrapper
                                exact
                                path="/cadastrar_crianca/:idMembro"
                                component={CadastrarCrianca}
                                isPrivate
                            />
                            <RouterWrapper
                                exact
                                path="/crianca/:idMembro/:idCrianca"
                                component={CadastrarCrianca}
                                isPrivate
                            /> */}
                            <RouterWrapper
                                exact
                                path="/membro/:idIgreja/:idMembro"
                                component={CadastrarMembro}
                                isPrivate
                            />
                            <RouterWrapper
                                exact
                                path="/atualizar_grupo/:idGrupoPequeno"
                                component={AtualizarGrupo}
                                isPrivate
                            />
                        </Main>
                    </RouterWrapper>
                    <Redirect
                        path="*"
                        to={{
                            pathname: '/grupos',
                        }}
                    />
                </Switch>
            </BrowserRouter>
        </MuiThemeProvider>
    );
}

export default App;
